import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/check-circle.svg'
import _imports_1 from '@/app/ui/assets/svg/info.svg'
import _imports_2 from '@/app/ui/assets/svg/ics_o_arrow_down.svg'
import _imports_3 from '@/app/ui/assets/svg/ics_o_arrow_up.svg'
import _imports_4 from '@/app/ui/assets/svg/chevron-down-red.svg'
import _imports_5 from '@/app/ui/assets/svg/chevron-up-red.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-274f866e")

_pushScopeId("data-v-274f866e")
const _hoisted_1 = { class: "flex items-center gap-2 flex-wrap bg-white rounded-lg font-montserrat" }
const _hoisted_2 = { class: "ml-2 text-white text-xl" }
const _hoisted_3 = { "data-testid": "booking-status-header-counter-total-shipment" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("/")
const _hoisted_5 = { "data-testid": "booking-status-header-counter-total-stt" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "",
  class: "w-5 h-5 mr-1"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "",
  class: "w-5 h-5 mr-1"
}, null, -1)
const _hoisted_8 = { class: "booking-status-failed-icon w-5 h-5 mr-1 flex items-center justify-center" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_10 = {
  key: 0,
  src: _imports_2,
  alt: "",
  class: "w-5 h-5 ml-1"
}
const _hoisted_11 = {
  key: 1,
  src: _imports_3,
  alt: "",
  class: "w-5 h-5 ml-1"
}
const _hoisted_12 = { class: "relative" }
const _hoisted_13 = {
  key: 0,
  src: _imports_4,
  alt: "",
  class: "w-5 h-5 ml-1"
}
const _hoisted_14 = {
  key: 1,
  src: _imports_5,
  alt: "",
  class: "w-5 h-5 ml-1"
}
const _hoisted_15 = { class: "text-sm divide-y divide-gray-200" }
const _hoisted_16 = { class: "booking-status-print-option-icon" }
const _hoisted_17 = { class: "whitespace-nowrap" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "bg-blue-lp-700 border border-blue-lp-500 text-white rounded-lg px-4 py-1 flex items-center font-semibold shadow text-sm",
      style: {
        backgroundImage: `url(${require('@/app/ui/assets/svg/bg-scan-shipment.svg')})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top right',
        backgroundSize: 'contain'
      }
    }, [
      _createTextVNode(_toDisplayString(_ctx.$t("bookingShipment.appsMarketplace.totalShipmentStt")) + " ", 1),
      _createVNode("span", _hoisted_2, [
        _createVNode("span", _hoisted_3, _toDisplayString(_ctx.shipmentAndSttCounts.totalShipment), 1),
        _hoisted_4,
        _createVNode("span", _hoisted_5, _toDisplayString(_ctx.shipmentAndSttCounts.totalStt), 1)
      ])
    ], 4),
    _createVNode("button", {
      id: "button_toggle_filter_success_create_shipment",
      "data-testid": "booking-status-header-filter-success",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onToggleStatus('success'))),
      class: [
        'border rounded-lg px-4 py-2 flex items-center text-sm font-medium border-green-500 text-green-700',
        !_ctx.isSuccessBooking ? 'bg-white' : 'bg-green-lp-500'
      ]
    }, [
      _hoisted_6,
      _createTextVNode(" " + _toDisplayString(_ctx.$t("bookingShipment.appsMarketplace.successBookedCount", {
          n: _ctx.statusCounts.success
        })), 1)
    ], 2),
    _createVNode("button", {
      id: "button_toggle_filter_not_booked_create_shipment",
      "data-testid": "booking-status-header-filter-not-booked",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onToggleStatus('notBooked'))),
      class: [
        'border rounded-lg px-4 py-2 flex items-center text-sm font-medium border-gray-500',
        !_ctx.isNotBooked ? 'bg-white text-gray-700' : 'bg-gray-lp-300 text-white'
      ]
    }, [
      _hoisted_7,
      _createTextVNode(" " + _toDisplayString(_ctx.$t("bookingShipment.appsMarketplace.notBookedCount", {
          n: _ctx.statusCounts.notBooked
        })), 1)
    ], 2),
    _createVNode("button", {
      id: "button_toggle_filter_failed_create_shipment",
      "data-testid": "booking-status-header-filter-failed",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onToggleStatus('failed'))),
      class: [
        'border rounded-lg px-4 py-2 flex items-center text-sm font-medium border-red-lp-2400 text-red-lp-2400',
        !_ctx.isFailedBooking ? 'bg-white' : 'bg-red-lp-50'
      ]
    }, [
      _createVNode("span", _hoisted_8, [
        _createVNode(_component_Icons, { name: "x-circle" })
      ]),
      _createTextVNode(" " + _toDisplayString(_ctx.$t("bookingShipment.appsMarketplace.failedBookedCount", {
          n: _ctx.statusCounts.failed
        })), 1)
    ], 2),
    _hoisted_9,
    _createVNode("button", {
      id: "button_toggle_filter_sort_create_shipment",
      "data-testid": "booking-status-header-sort-toggle",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleSort())),
      class: "border border-red-lp-2400 text-red-lp-100 px-3 py-2 rounded-md text-sm font-medium flex bg-red-100 transition"
    }, [
      _createTextVNode(_toDisplayString(_ctx.isAscendingSort
          ? _ctx.$t("bookingShipment.appsMarketplace.sortOldest")
          : _ctx.$t("bookingShipment.appsMarketplace.sortNewest")) + " ", 1),
      (_ctx.isAscendingSort)
        ? (_openBlock(), _createBlock("img", _hoisted_10))
        : (_openBlock(), _createBlock("img", _hoisted_11))
    ]),
    _createVNode("div", _hoisted_12, [
      _createVNode("button", {
        id: "button_print_all_create_shipment",
        "data-testid": "booking-status-header-print-all-trigger",
        onClick: _cache[5] || (_cache[5] = 
          (event) => {
            _ctx.togglePanel(event);
          }
        ),
        class: "border border-red-lp-2400 text-red-lp-100 px-3 py-2 rounded-md text-sm font-medium transition flex items-center"
      }, [
        _createTextVNode(_toDisplayString(_ctx.$t("bookingShipment.appsMarketplace.printAll")) + " ", 1),
        (!_ctx.showPrintDropdown)
          ? (_openBlock(), _createBlock("img", _hoisted_13))
          : (_openBlock(), _createBlock("img", _hoisted_14))
      ]),
      _createVNode(_component_OverlayPanel, {
        ref: "op",
        appendTo: "body",
        onShow: _ctx.onPrintDropdownShow,
        onHide: _ctx.onPrintDropdownHide,
        style: {"font-family":"Montserrat","padding":"0px"},
        class: "shipment-booking-overlay booking-status-print-overlay"
      }, {
        default: _withId(() => [
          _createVNode("ul", _hoisted_15, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.printOptions, (option) => {
              return (_openBlock(), _createBlock("li", {
                key: option.value,
                "data-testid": option.testId,
                class: "booking-status-print-option",
                onClick: ($event: any) => (_ctx.emitPrint(option.value))
              }, [
                _createVNode("span", _hoisted_16, [
                  _createVNode(_component_Icons, { name: "printer" })
                ]),
                _createVNode("span", _hoisted_17, _toDisplayString(option.label), 1)
              ], 8, ["data-testid", "onClick"]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["onShow", "onHide"])
    ])
  ]))
})